import { ForwardedRef, forwardRef, useEffect, useRef, useState } from "react";
import { Icons } from "../../../lib/icons";
import './MainSlide.css';


/**
 * Wait policy for the content
 * END: wait until the video ends + timeout (only works with videos)
 * NONE: don't wait until the video ends (only wait the timeout period)
 */
enum WaitPolicy {
  END, NONE
}
interface AnimationPolicy {
  ref: any,
  src: string,
  waitPolicy: WaitPolicy,
  timeout: number
}

const MainSlide = forwardRef((_, ref: ForwardedRef<HTMLDivElement>) => {
  const animationRef = useRef<HTMLVideoElement>(null);
  const billetFrontRef = useRef<HTMLImageElement>(null);
  const flyAroundRef = useRef<HTMLVideoElement>(null);
  const timeline: AnimationPolicy[] = [
    { ref: animationRef, src: '/videos/billet-animation.mp4', waitPolicy: WaitPolicy.END, timeout: 2000, },
    { ref: flyAroundRef, src: '/videos/fly-around.mp4', waitPolicy: WaitPolicy.END, timeout: 0, },
    { ref: billetFrontRef, src: '/img/home/slides/home/billet-front.jpg', waitPolicy: WaitPolicy.NONE, timeout: 0, }
  ]
  useEffect(() => {
    const playVideo = () => {
      loadMedia(timeline[0]);
      applyAnimationPolicy(timeline);
    };
  
    // Play the video on component mount
    playVideo();
  
    // Clean up to ensure correct behavior on re-navigation
    return () => {
      if (animationRef.current) {
        animationRef.current.pause();
        animationRef.current.currentTime = 0;
      }
      if (flyAroundRef.current) {
        flyAroundRef.current.pause();
        flyAroundRef.current.currentTime = 0;
      }
    };
  }, []);  

  const applyAnimationPolicy = (timeline: AnimationPolicy[]) => {
    const a0 = timeline[0];
    a0.ref.current.classList.add('show');
    if (a0.ref.current instanceof HTMLVideoElement) {
      const vidRef: HTMLVideoElement = a0.ref.current;
      vidRef.play();
      // start loading next resource
      if (timeline[1]) {
        loadMedia(timeline[1]);
      }
      // wait until it ends, then apply a timeout if the wait policy is "END"
      if (a0.waitPolicy === WaitPolicy.END) {
        vidRef.addEventListener("ended", function () {
          timeout(timeline);
        });
      } else {
        timeout(timeline);
      }
    } else if (a0.ref.current instanceof HTMLImageElement) {
      timeout(timeline);
    }
  }
  const loadMedia = (segment: AnimationPolicy) => {
    segment.ref.current.src = segment.src;
  }

  const timeout = (timeline: AnimationPolicy[]) => {
    const ref = timeline[0].ref.current;
    setTimeout(() => {
      // pause if it's a video
      if (ref instanceof HTMLVideoElement) {
        const vid: HTMLVideoElement = ref;
        vid.pause();
      }
      // if there is a next element, then hide it
      if (timeline.length > 1) {
        ref.classList.remove('show');
        applyAnimationPolicy(timeline.slice(1));
      }
    }, timeline[0].timeout);
  }

  return (
    <div className="main-slide">
      {/* Below is where you put the elements to show up in the animation, in no order */}
      <video className="background fullscreen" playsInline muted ref={animationRef}></video>
      <img className="background fullscreen" src="/img/home/slides/home/billet-front.jpg" alt="Front shot of Billet Precision" ref={billetFrontRef} />
      <video className="background fullscreen" id="fly-around" playsInline muted ref={flyAroundRef}></video>
      {/* Above is where you put the elements to show up in the animation, in no order */}

      {/*  */}
      <div className="main-slide-overlay"></div>
      {/* Hint */}
      <div className="hint" id="arrow-down">
        <img className="hint-img" src={Icons.ARROW_DOWN} alt="scroll down" />
      </div>
    </div>
  )
});

export default MainSlide;